'use strict'

const { pubdb } = Function('return this')();
const {
    $, review_sortable, review_filter_years, status_otf, display_pub, confirm, status_call1, echo, window,
} = pubdb;
const { JSON } = window;
const { parse } = JSON;


review_sortable();
review_filter_years(0, 3);

status_otf(function (cb, shall_check) {
    const e = /^pub(\d+)$/.exec(cb.attr('name'));
    if (e) {
        return [+e[1], (shall_check ? 'set_mark' : 'del_mark'), []];
    }
});

$(function () {
    [].forEach.call($('#pubdb_data [data-pub]'), function (dest) {
        dest = $(dest);
        let pub = dest.data('pub');
        if (typeof pub === 'string') {
            pub = parse('pub');
        }
        display_pub([pub], dest);
    });

    $('#all-pubs-cb').on('click', function () {
        let list = [].slice.call($('input[type=checkbox][name^=pub]'));

        function do_fn (op, inverse) {
            let left = list.length;
            let succeeded = 0;
            let failed = 0;

            function done (cb, success) {
                cb.checked = inverse ^ success;

                if (success) {
                    ++succeeded;
                } else {
                    ++failed;
                }

                if (--left === 0) {
                    echo('confirm', `Fertig: ${succeeded}×erfolgreich, ${failed}×fehlgeschlagen`);
                }
            }

            list.forEach(cb => {
                let [, id] = /^pub(\d+)$/.exec(cb.name);
                status_call1(id, op, [], success => { done(cb, success) });
            })
        }

        function del_mark (arg) {
            if (arg !== del_mark) {
                list.shift().checked = false;
            }

            let cb = list[0];
            if (!cb) {
                echo('confirm', 'Fertig')
            } else {
                let [, id] = /^pub(\d+)$/.exec(cb.name);
                status_call1(id, 'del_mark', [], del_mark);
            }
        }

        confirm('Alle akzeptieren?', `Wollen Sie wirklich alle Änderungen akzeptieren?`, [
            ['☑ alle akzeptieren',   () => { do_fn('set_mark', 0) }],
            ['☐ alle deakzeptieren', () => { do_fn('del_mark', 1) }],
            ['abbrechen'],
        ]);
    });

    $('.container').css({
        margin: 0,
        padding: 0,
        maxWidth: 'unset',
    });

    [].forEach.call($("[data-interne_bemerkungen]"), row => {
        row = $(row);
        const text = $('<div/>')
            .text('Bemerkung')
            .css({
                display: "inline-block",
                padding: '0.25rem 0.5rem',
                width: 'max-content',
                backgroundColor: '#f0c0c0',
            });
        pubdb.add_tooltip(text, parse(row.data('interne_bemerkungen')));
        text.appendTo(row.find(':first'));
    });
})
